import styled from "styled-components";
import { ResultDataContainer } from "../../health/health-result/result-data-style";

export const HealtForeignersResultDataContainer = styled(ResultDataContainer)``;
